import type { ConnectionResponse } from "@/react/api/admin/connections";
import { ConnectionStatus } from "@/react/api/admin/connections";
import { useCurrentUser } from "@/react/contexts/punditUserContext";

export const useDetermineConnectionStatus = (
  connection?: ConnectionResponse,
) => {
  const currentUser = useCurrentUser();

  const isDetachedOrWithdrawn =
    connection &&
    (connection.status === ConnectionStatus.DETACHED ||
      connection.status === ConnectionStatus.WITHDRAWN);

  const isIgnored =
    connection &&
    connection.status === ConnectionStatus.IGNORED &&
    connection.initiator.user_id === currentUser?.id;

  const isCurrentUserSentConnection =
    connection &&
    connection.status === ConnectionStatus.PENDING &&
    connection.initiator.user_id === currentUser?.id;

  const isOtherUserSentConnection =
    connection &&
    connection.status === ConnectionStatus.PENDING &&
    connection.initiator.user_id !== currentUser?.id;

  return {
    isEmpty: !connection || isDetachedOrWithdrawn || isIgnored,
    isActive: connection?.status === ConnectionStatus.ACTIVE,
    isCurrentUserSentConnection,
    isOtherUserSentConnection,
  };
};
